export default __webpack_public_path__ + "closed655a8.svg";